import Container, { Service } from 'typedi';
import { NativeService } from '../../native/native.service';
import { ILoginModel } from '../models';

@Service()
export abstract class LoginDataBuilder<T extends ILoginModel> {
    protected readonly _nativeService: NativeService;

    constructor() {
        this._nativeService = Container.get(NativeService);
    }

    public abstract Build(data: any): Promise<T>;

    protected _setLoginNativeProps = (loginData: T) => {
        const { IDFV, Bundle, FirebaseAppInstanceID, FirebaseAppID, AppID, AFUDID, DeviceID } =
            this._nativeService.getNativeStoreData();

        loginData.AppID = AppID;
        loginData.AppsFlyerID = AFUDID;
        loginData.IDFV = IDFV;
        loginData.BundleId = Bundle;
        loginData.DeviceId = DeviceID;
        loginData.FirebaseAppID = FirebaseAppID;
        loginData.FirebaseAppInstanceID = FirebaseAppInstanceID;
    };
}
